<template>
  <el-row class="mb-3" v-if="amReady">
    <div class="m-0 p-0 mb-4" v-if="formHeader">
      <h6>{{ this.getFormTitle }}</h6>
    </div>
    <div class="mb-2" v-else></div>

    <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
      <dg-text-field
          :control="control"
          :field_span="22"
            :label_span="22"
          field_mark="required"
          label="name"
          name="name"
          placeholder="Fusion CLI Server"
          rules="required"></dg-text-field>

      <dg-text-field
          :control="control"
          :field_span="22"
            :label_span="22"
          field_mark="optional"
          label="note"
          name="note"
          placeholder=""
          rules=""></dg-text-field>
    </el-col>


    <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
      <dg-text-field
          :control="control"
          :field_span="22"
            :label_span="22"
          field_mark="required"
          label="host"
          name="host"
          placeholder="http://162.42.32.2"
          rules="required"></dg-text-field>
    </el-col>

    <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
      <dg-text-field
          :control="control"
          :field_span="22"
            :label_span="22"
          field_mark="required"
          label="ssh_port"
          name="port"
          placeholder="22"
          rules="required"></dg-text-field>
    </el-col>

    <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
      <dg-text-field
          :control="control"
          :field_span="22"
            :label_span="22"
          field_mark="required"
          label="ssh_password"
          name="ssh_password"
          placeholder="Secret"
          rules="required"
          type="password"></dg-text-field>
    </el-col>


    <el-col :span="24" class="mt-2 border-top">
      <el-col :class="$langConfig.cssClass" :span="12" class="mt-4">
        <dg-label-field class="error-field-validate-message" label="fields_do_not_match_the_required_criteria"
                        v-show="!this.validData"></dg-label-field>
      </el-col>
      <el-col :span="12" class="pt-3 text-right">
        <dg-confirm-button
            :loading="requestOn"
            :onConfirm="removeAction"
            :translate="false"
            class="mr-2"
            confirmButtonType="danger"
            fieldSize="mini"
            icon="el-icon-delete"
            popIcon="el-icon-delete"
            text="remove"
            title="sure to removing this record ?"
            type="danger"
            v-if="editMode"></dg-confirm-button>

        <dg-button :click="cancelEditable" class="mr-2" fieldSize="mini" icon="el-icon-close" text="cancel"
                   type="warning" v-if="editable && editMode"></dg-button>
        <dg-button :click="changeEditable" fieldSize="mini" icon="el-icon-edit" text="edit" type="success"
                   v-if="!editable && editMode"></dg-button>
        <dg-confirm-button
            :icon="actionButtonIcon"
            :loading="requestOn"
            :onConfirm="createModule"
            :text="actionButtonLabel"
            :translate="false"
            :type="actionButtonType"
            fieldSize="mini"
            v-if="editable"></dg-confirm-button>
      </el-col>
    </el-col>
  </el-row>
</template>

<script>


import fieldController from 'devegram-vue-data-collecter-eui/src/mixins/fieldController';
import module from './../index.js'
import {notify} from '@/system-services/notify.js'

export default {
  mixins: [fieldController],
  props: {
    formHeader: {
      required: false,
      default: false
    },
    formTitle: {
      required: false
    },
    editMode: {
      required: true,
      type: Boolean
    },
    onEditCallback: {
      required: false
    },
    onCreateCallback: {
      required: false
    },
  },
  data() {
    return {
      control: this,
      amReady: true,
      requestOn: false,
      editable: !this.editMode,
      dropDownList: [],
      module: {
        ...module
      },
      categoriesSuggestion: [
        {"value": "vue", "link": "https://github.com/vuejs/vue"},
        {"value": "element", "link": "https://github.com/ElemeFE/element"},
        {"value": "cooking", "link": "https://github.com/ElemeFE/cooking"},
        {"value": "mint-ui", "link": "https://github.com/ElemeFE/mint-ui"},
        {"value": "vuex", "link": "https://github.com/vuejs/vuex"},
        {"value": "vue-router", "link": "https://github.com/vuejs/vue-router"},
        {"value": "babel", "link": "https://github.com/babel/babel"}
      ]
    }
  },
  computed: {
    ...$mapState('server-state', ['openedEntity']),
    ...$mapState('ajaxManager', ['loadingRequests']),
    getFormTitle: function () {
      if (this.formTitle) {
        return this.formTitle
      } else {
        return ((!this.editMode) ? this.$ml.get('create') : this.$ml.get('edit')) + ' ' + this.module.info.caption
      }
    },
    actionButtonLabel: function () {
      if (!this.editMode) {
        return 'create';
      } else {
        return 'save'
      }
    },
    actionButtonIcon: function () {
      if (!this.editMode) {
        return 'el-icon-plus';
      } else {
        return 'el-icon-check'
      }
    },
    actionButtonType: function () {
      if (!this.validData) {
        return 'danger btn-small';
      } else {
        if (!this.editMode) {
          return 'primary app-bg-primary';
        } else {
          return 'primary'
        }
      }
    }
  },
  beforeMount() {
    this.getEntityDropDownList().then((r) => {
      this.dropDownList = r
    })
  },
  methods: {
    ...$mapActions('server-state', ['addEntity']),
    ...$mapActions('server-api', {getEntityDropDownList: 'getDropDownList'}),
    cancelEditable() {
      let context = this
      this.amReady = false
      this.editable = false
      $vue.nextTick(() => {
        context.amReady = true
      })
    },
    changeEditable() {
      this.editable = !this.editable
    },
    getEntityField() {
      return JSON.parse(this.openedEntity.fields);
    },
    removeAction(params) {
      let cxt = this
      this.requestOn = true
      this.$store.dispatch(this.module.info.name + '-api/remove', {id: this.recordId}).then(response => {
        notify({
          type: 'success',
          title: this.$ml.get('deleted'),
          message: '',
          position: 'topRight',
          close: false,
          timeout: 1900,
          animateInside: true,
        });
        cxt.amReady = false
      })
    },
    createModule() {
      this.validateFields().then(result => {
        if (!result) return

        this.requestOn = true
        let context = this;
        let data = {data: this.dataModel};
        if (this.editMode) {
          data.id = this.dataToBind.id;
        }

        let api = (this.editMode) ? 'update' : 'create';
        this.$store.dispatch(this.module.info.name + '-api/' + api, data).then(response => {
          this.amReady = false
          notify({
            type: 'success',
            title: this.$ml.get('successfully'),
            message: '',
            position: 'topRight',
            close: false,
            timeout: 1900,
            animateInside: true,
          });

          $vue.nextTick(() => {
            context.amReady = true
            context.requestOn = false
            if (context.editMode) {
              if (context.onEditCallback) {
                context.onEditCallback(response.data)
              }
            } else {
              if (context.onCreateCallback) {
                context.onCreateCallback(response.data)
              }
            }
          })
          // this.$router.push({ name: this.module.stateName + '-module-list', params: {}}).then( response => {})
        }).catch(error => {
          console.log('catch error', error)
          this.setfieldsErrorMessage({
            fieldsErrors: error.response.data
          });
        }).finally(() => {
          this.requestOn = false
        })

      })
    }
  }
}
</script>
